import DashboardLayout from './DashboardPage/DashboardLayout';

const DashboardPage = () => {
  return <DashboardLayout />;
};

export default DashboardPage;
